import { Body, breakpoints, Button, Dropdown, Margin, MoreSvg, Spacer } from '@spritz-finance/ui'
import { useState } from 'react'
import styled from 'styled-components'
import { KeyValuePill } from '../../../../components/KeyValuePill'
import { Card } from '../../../../components/Layout/Card'
import { Column } from '../../../../components/Layout/Column'
import { Row } from '../../../../components/Layout/Row'
import { toHumanReadableAccountType } from '../../utils'
import { BankAccount } from '../BankAccounts'
import { PaymentButton } from '../payment/PaymentButton'
import PaySomeoneImage from '../../../../assets/icons/pay-someone.png'
import { BillIcon, typeDescription } from '../../../bills/components/bills/BillIcon'
import { BillType } from '../../../../graphql/generated/graphql'
import { DisplayCard } from '../../../bills/components/bills/BillCard'
import { themedImage } from '../../../../theme/utils'

const PaySomeone = styled.img`
    width: 40px;
    height: 40px;
`

const InstitutionImage = styled.img`
    width: 47px;
    height: 47px;
`

const StyledCard = styled(Card)`
    min-width: 350px;
    padding: ${Margin.Large};
    padding-top: ${Margin.Med};

    ${breakpoints.xsmall} {
        min-width: auto;
        padding: ${Margin.Med};
        padding-top: ${Margin.Small};
    }
`

export const AccountCard = ({
    account,
    onRemoveAccount,
    onRenameAccount,
}: {
    account: BankAccount
    onRemoveAccount: (account: BankAccount) => void
    onRenameAccount: (account: BankAccount) => void
}) => {
    const [maskAccount, setMaskAccount] = useState(true)
    const [maskRouting, setMaskRouting] = useState(true)

    const isPayOthers = !account.ownedByUser

    const accountNum = maskAccount
        ? `••••••${account.accountNumber?.slice(-4)}`
        : account.accountNumber
    const routingNum = maskRouting ? '•••••••••' : account.routingNumber

    return (
        <StyledCard>
            <Row align="space-between">
                <Row>
                    {isPayOthers && (
                        <>
                            <PaySomeone src={themedImage('paySomeone', PaySomeoneImage)} />
                            <Spacer width={16} />
                        </>
                    )}
                    {!isPayOthers && account?.institution?.logo && (
                        <>
                            <InstitutionImage src={account.institution.logo!} />
                            <Spacer width={16} />
                        </>
                    )}

                    <Column>
                        <Body.Med size={14} secondary>
                            {isPayOthers ? 'Spritz Pay' : toHumanReadableAccountType(account)}
                        </Body.Med>
                        <Spacer height={4} />
                        <Body.SmBold size={18}>{account.name}</Body.SmBold>
                    </Column>
                </Row>
                <Spacer width={16} />
                <Dropdown.Menu
                    minWidth={160}
                    align="end"
                    anchor={
                        <Button.Icon
                            icon={MoreSvg}
                            fillColor
                            size={24}
                            style={{ minWidth: 0, marginRight: -12 }}
                        />
                    }
                >
                    <Dropdown.Item onClick={() => onRenameAccount(account)}>
                        <Row align="space-between">
                            <Body.Med size={14}>Rename</Body.Med>
                        </Row>
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => onRemoveAccount(account)}>
                        <Row align="space-between">
                            <Body.Med size={14}>Remove</Body.Med>
                        </Row>
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Row>

            <Spacer height={24} />

            {isPayOthers && (
                <>
                    <DisplayCard>
                        <BillIcon type={'pay-others'} />
                        <Spacer height={8} />
                        <Body.Med size={14} align="center">
                            Pay Others
                        </Body.Med>
                    </DisplayCard>
                    <Spacer height={16} />
                </>
            )}

            <KeyValuePill keyText="Account number:" color="#f2ffdc">
                <Row align="space-between" flex={1}>
                    <Body.Bold size={14}>{accountNum}</Body.Bold>
                    <button onClick={() => setMaskAccount((curr) => !curr)}>
                        <Body.Med size={10}>{maskAccount ? 'Show' : 'Hide'}</Body.Med>
                    </button>
                </Row>
            </KeyValuePill>
            <Spacer height={8} />
            <KeyValuePill keyText="Routing number:" color="#FFF2E2">
                <Row align="space-between" flex={1}>
                    <Body.Bold size={14}>{routingNum}</Body.Bold>
                    <button onClick={() => setMaskRouting((curr) => !curr)}>
                        <Body.Med size={10}>{maskRouting ? 'Show' : 'Hide'}</Body.Med>
                    </button>
                </Row>
            </KeyValuePill>

            <Spacer height={24} />
            <Row align="center">
                <PaymentButton account={account} isPayOthers={isPayOthers} />
            </Row>
        </StyledCard>
    )
}
